/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passwordrequired1Inputs */

const zh_auth_passwordrequired1 = /** @type {(inputs: Auth_Passwordrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入密码`)
};

const en_auth_passwordrequired1 = /** @type {(inputs: Auth_Passwordrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password is required`)
};

const es_auth_passwordrequired1 = /** @type {(inputs: Auth_Passwordrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La contraseña es obligatoria`)
};

/**
* | output |
* | --- |
* | "Password is required" |
*
* @param {Auth_Passwordrequired1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_passwordrequired1 = /** @type {((inputs?: Auth_Passwordrequired1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passwordrequired1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_passwordrequired1(inputs)
	if (locale === "en") return en_auth_passwordrequired1(inputs)
	return es_auth_passwordrequired1(inputs)
});
export { auth_passwordrequired1 as "auth_passwordRequired" }